/** Read the server instant on the event's wall calendar. h23 avoids the
 * locale-dependent 24:00 spelling, which would break string comparisons. */
export function wallClock(timezone: string | undefined, now = Date.now()): string | undefined {
  if (!timezone) return undefined;
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: timezone,
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(now);
  const read = (type: Intl.DateTimeFormatPartTypes): string => parts.find((part) => part.type === type)!.value;
  return `${read("year")}-${read("month")}-${read("day")}T${read("hour")}:${read("minute")}`;
}

